import { methodsMixin } from './methods';
import { notificationsMixin } from './notifications';

/**
   *  Mixin do zarządzania modalem edycji
   *  Zawiera pola
   *  - `idToEdit` - identyfikator edytowanego obiektu
   *  - `showModal` - czy pokazać modal dodawania / edycji
   *  Zawiera metody
   *  - `showEditModal(id)` - wyświetla modal edycji encji
   *  - `showAddModal()` - wyświetla modal dodania encji
   *  - `hideModal()` - ukrywa modal edycji/dodania
   *  - `update(data)` - aktualizuje encję
   *  - `add(data)` - dodaje encję
  
   *
   * @export
   * @param {*} moduleName - nazwa modułu store
   * @param {*} messages  - obiekt z powiadomieniami do wyświetlenia po wykonaniu akcji i w przypadku niepowodzenia
   * @param {string} messages.getError - wiadomość w przypadku niepowodzenia przy pobieraniu encji
   * @param {string} messages.updated - wiadomość po aktualizacji encji
   * @param {string} messages.updateError - wiadomość w przypadku niepowodzenia przy aktualizacji encji
   * @returns
   */
export function modalFormMixin(moduleName, messages) {
  return {
    mixins: [notificationsMixin, methodsMixin],
    /**
     * Dane modułu
     *
     * @returns
     */
    data() {
      return {
        moduleName,
        idToEdit: undefined,
        showModal: false
      };
    },
    methods: {
      /**
       * Otwiera modal do edycji encji
       *
       * @param {*} id
       */
      showEditModal(id) {
        this.idToEdit = id;
        this.$store
          .dispatch(`${moduleName}/get`, id)
          .then(() => this.showAddModal())
          .catch(err => this.notifyError(messages.getError));
      },

      // @vuese
      // Otwiera modal do dodania encji
      showAddModal() {
        this.showModal = true;
      },
      // @vuese
      // Ukrywa modal dodawania/edycji
      hideModal() {
        this.$set(this, 'showModal', false);
        this.$set(this, 'idToEdit', undefined);
      },
      // @vuese
      // Zapisuje encję
      add(data) {
        this.$store
          .dispatch(`${moduleName}/add`, this.prepareModel(this.deepClone(data)))
          .then(id => {
            this.notifySuccess(messages.added);
            data.id = id;
            if (this.afterAdd) {
              this.afterAdd(data);
            }
            this.hideModal();
          })
          .catch(err => {
            err.graphQLErrors[0]
              ? this.notifyError(messages.addError, [err.graphQLErrors[0].message])
              : this.notifyError(messages.addError);
          });
      },
      // @vuese
      // Aktualizuje encję
      update(data) {
        this.$store
          .dispatch(`${moduleName}/update`, this.prepareModel(this.deepClone(data)))
          .then(() => {
            this.notifySuccess(messages.updated);
            if (this.afterUpdate) {
              this.afterUpdate(data);
            }
            this.hideModal();
          })
          .catch(err => this.notifyError(messages.updateError));
      },
      // @vuese
      // Funkcja mapująca model przed zapisem
      prepareModel(model) {
        return model;
      }
    }
  };
}
